import React from 'react';

interface Props {
  count: number;
  singleText: string;
  pluralText: string;
  afterText?: string | null | undefined;
}

export default function SingleOrPluralText({ count, singleText, pluralText, afterText }: Props) {
  if (count >= 2) {
    return (
      <>
        {pluralText.replace('{}', count as any)}
        {afterText || ''}
      </>
    );
  }
  return (
    <>
      {singleText.replace('{}', count as any)}
      {afterText || ''}
    </>
  );
}
